// extracted by mini-css-extract-plugin
export default {"wideTooltip":"ItemCard_wideTooltip__7YbVJ","toggle":"ItemCard_toggle__ETB+G","toggleKnob":"ItemCard_toggleKnob__x-Op2","toggleOn":"ItemCard_toggleOn__M6QF7"};